export default "__VITE_ASSET__b29f5f99__"